import { Card, Col, Row } from 'antd'
import React from 'react'
import './projectCards.css'
import TitleD from '../title/Title'
import { Typography, Space } from 'antd'

const { Text, Link } = Typography

const cards = [
  {
    title: 'React Quiz',
    desc: (
      <>
        <p>Приложение для прохождения и создания Квизов.</p>
        Используемые технологии:
        <ul>
          <li>React-create-app</li>
          <li>Ant-design</li>
          <li>SCSS</li>
          <li>React-Router</li>
          <li>FireBase</li>
          <li>Axios</li>
          <li>Redux/thunk</li>
        </ul>
        <Link
          href="https://greed2kk.github.io/react-quiz"
          target="_blank"
        >
          Demo
        </Link>
      </>
    ),
    link: 'https://github.com/Greed2kk/react-quiz',
  },
  {
    title: 'Excel JS',
    desc: (
      <>
        <p>
          Приложение для реализации части основных функции
          excel на чисто JS, с имплементацией самописных
          популярных библиотек.
        </p>
        Используемые технологии:
        <ul>
          <li>ES6</li>
          <li>SCSS</li>
          <li>Webpack</li>
          <li>Redux(Реализация основной концепции)</li>
          <li>jQuery(Реализация основной концепции)</li>
          <li>jest</li>
        </ul>
        <Link
          href="https://greed2kk.github.io/excel_practice/"
          target="_blank"
        >
          Demo
        </Link>
      </>
    ),
    link: 'https://github.com/Greed2kk/excel_practice',
  },
  {
    title: 'Gas Stations',
    desc: (
      <>
        <p>Приложение для отображения заправок на карте.</p>
        Используемые технологии:
        <ul>
          <li>DRF</li>
          <li>Bb&Mn</li>
          <li>Leaflet</li>
          <li>Bootstrap</li>
          <li>Ol</li>
          <li>handlebars</li>
          <li>underscore</li>
        </ul>
      </>
    ),
    link: 'https://github.com/Greed2kk/gs_rnd',
  },
]

const ProjectCards = () => (
  <>
    <TitleD text="Pet-projects" size="5" />
    <div className="site-card-wrapper">
      <Row gutter={16}>
        {cards.map(({ title, desc, link }, index) => (
          <Col span={8} key={index}>
            <Card
              size="small"
              style={{
                cursor: 'default',
                width: 200,
              }}
              hoverable
              key={index}
              title={title}
              bordered={false}
              extra={<a href={link}>Git-Hub</a>}
            >
              <Space direction="vertical">
                <Text>{desc}</Text>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  </>
)

export default ProjectCards
